import React, { useState } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { Switch, Input, Form, message, Modal, Button, Col, Row } from "antd";

import { useGlobalContext } from "../context/provider"
import { AxiosPostData } from "../context/axiosfunction";
import Link from "next/link";
import BookOncheckcode from '../Responsive/home/book/BookOncheckcode'


const MobileHeaderMenu = ({ menu, setMenu, hasFreeCampaigns = false }) => {

    const { theme, setTheme, headers, API } = useGlobalContext()

    const [modalRedeem, setRedeem] = useState(false)
    const [FormRedeem] = Form.useForm()
    const [messageAPI, contextHolder] = message.useMessage()
    const [modalsuccess, setModalSuccess] = useState(false)
    const [datacodeset, setdatacodeset] = useState({})
    const [selectedSeriesIds, setSelectedSeriesIds] = useState([])

    const CheckCode = async (code) => {
        if (!code || code === '') {
            return messageAPI.open({
                type: 'warning',
                content: 'กรุณากรอกคูปอง'
            })
        }

        try {
            const response = await AxiosPostData(API, '/api/checkauthent/check_code', code, headers)

            if (response.status === 'success') {
                messageAPI.open({
                    type: 'success',
                    content: response.message
                })
                setdatacodeset(response.data)
                setSelectedSeriesIds([]) // reset selections
            } else {
                setdatacodeset([])
                setSelectedSeriesIds([])
                messageAPI.open({
                    type: response.status === 'warning' ? 'warning' : 'error',
                    content: response.message || ''
                })
            }
        } catch (error) {
            messageAPI.open({
                type: 'error',
                content: 'เกิดข้อผิดพลาดในการเชื่อมต่อ'
            })
        }
    }

    const CheckRedeem = async (data) => {
        const senddata = {
            code: data.code,
            selected_series_ids: selectedSeriesIds
        }
        try {
            const response = await AxiosPostData(API, '/api/checkauthent/check_redeem', senddata, headers)

            if (response.status === 'success') {
                messageAPI.open({
                    type: 'success',
                    content: response.message
                })
                setRedeem(false)
                setModalSuccess(true)
            } else {
                messageAPI.open({
                    type: response.status === 'warning' ? 'warning' : 'error',
                    content: response.message || 'เกิดข้อผิดพลาด'
                })
            }
        } catch (error) {
            messageAPI.open({
                type: 'error',
                content: 'เกิดข้อผิดพลาดในการเชื่อมต่อ'
            })
        }
    }

    const handleSelectBook = (bookId, groupId, groupPickLimit, groupBooks, groupPickLimitPerGroup) => {
        setSelectedSeriesIds((prev) => {
            const isSelected = prev.includes(bookId);
            if (isSelected) {
                return prev.filter((id) => id !== bookId);
            } else {
                // 1. Check limit per choice group (pick_limit of group)
                if (groupPickLimitPerGroup !== null && groupPickLimitPerGroup !== undefined) {
                    const selectedInThisGroup = prev.filter(id => groupBooks.some(b => b.id === id));
                    if (selectedInThisGroup.length >= groupPickLimitPerGroup) {
                        messageAPI.warning(`คุณสามารถเลือกในเรื่องนี้ได้สูงสุด ${groupPickLimitPerGroup} เล่ม`);
                        return prev;
                    }
                }

                // 2. Check total groups touched limit (group_pick_limit of batch)
                if (groupPickLimit !== null && groupPickLimit !== undefined) {
                    const touchedGroupIds = new Set();
                    touchedGroupIds.add(groupId);

                    prev.forEach(selectedId => {
                        datacodeset.groups?.forEach(g => {
                            if (g.books.some(b => b.id === selectedId)) {
                                touchedGroupIds.add(g.id);
                            }
                        });
                    });

                    if (touchedGroupIds.size > groupPickLimit) {
                        messageAPI.warning(`คุณสามารถเลือกได้สูงสุด ${groupPickLimit} เรื่อง`);
                        return prev;
                    }
                }

                return [...prev, bookId];
            }
        });
    };

    return (
        <>
            {contextHolder}
            <Modal
                footer={null}
                onCancel={() => {
                    setRedeem(false);
                    FormRedeem.resetFields();
                    setdatacodeset([]);
                    setSelectedSeriesIds([]);
                }}
                width={760}
                className={`redeem-modal ${theme}`}
                open={modalRedeem}
            >
                <Form
                    onFinish={CheckRedeem}
                    form={FormRedeem}
                    className="py-[32px] px-[40px] space-y-6"
                    layout="vertical"
                >
                    {/* Input + ตรวจสอบ */}
                    <Form.Item
                        name="code"
                        label={<div className="text-primary text-[20px]">กรอกรหัสรับ ebook</div>}
                        rules={[{ required: true, message: "กรุณากรอกรหัสคูปอง" }]}
                    >
                        <Row gutter={8}>
                            <Col flex="auto">
                                <Input autoComplete="off" placeholder="ใส่รหัสคูปอง" />
                            </Col>
                            <Col>
                                <button
                                    className="h-full px-[2em] btn-primary"
                                    type="button"
                                    onClick={() => {
                                        const code = FormRedeem.getFieldValue("code");
                                        CheckCode(code);
                                    }}
                                >
                                    ตรวจสอบ
                                </button>
                            </Col>
                        </Row>
                    </Form.Item>

                    {/* Book list (grant_all mode) */}
                    {(!datacodeset.selection_mode || datacodeset.selection_mode === 'grant_all') && datacodeset.book?.length > 0 && (
                        <div>
                            <BookOncheckcode data={datacodeset.book} mass={datacodeset.period?.days ? datacodeset.period.days + ' วัน' : 'เข้าชั้นหนังสือ'} />
                        </div>
                    )}

                    {/* Choice selection list (choose mode) */}
                    {datacodeset.selection_mode === 'choose' && datacodeset.groups?.length > 0 && (
                        <div className="space-y-6">
                            <div className="flex items-center gap-3 text-lg font-semibold my-4">
                                <img
                                    src="https://eve-image.eveebook.com/image.eveebook/mascot/happy.png"
                                    alt="happy_rabbit"
                                    className="w-10 h-10"
                                />
                                <div className="text-primary">
                                    กรุณาเลือกหนังสือที่ต้องการรับ
                                    {datacodeset.group_pick_limit && (
                                        <span className="text-special ml-1">
                                            (เลือกได้สูงสุด {datacodeset.group_pick_limit} เรื่อง)
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2">
                                {datacodeset.groups.map((group) => {
                                    const selectedInGroup = selectedSeriesIds.filter(id =>
                                        group.books.some(b => b.id === id)
                                    );

                                    return (
                                        <div
                                            key={group.id}
                                            className="p-4 rounded-xl border border-gray-200 backdrop-blur-md bg-white/40 shadow-sm space-y-3"
                                        >
                                            <div className="flex justify-between items-center border-b pb-2">
                                                <span className="font-semibold text-primary text-[16px]">
                                                    {group.name}
                                                </span>
                                                <span className="text-sm text-gray-500">
                                                    {group.pick_limit
                                                        ? `เลือกได้ ${selectedInGroup.length}/${group.pick_limit} เล่ม`
                                                        : `เลือกได้ไม่จำกัด (${selectedInGroup.length} เล่มที่เลือก)`
                                                    }
                                                </span>
                                            </div>

                                            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                                                {group.books.map((book) => {
                                                    const isChecked = selectedSeriesIds.includes(book.id);
                                                    return (
                                                        <div
                                                            key={book.id}
                                                            onClick={() => handleSelectBook(
                                                                book.id,
                                                                group.id,
                                                                datacodeset.group_pick_limit,
                                                                group.books,
                                                                group.pick_limit
                                                            )}
                                                            className={`cursor-pointer group flex flex-col items-center p-2 rounded-lg transition-all duration-300 relative border ${isChecked
                                                                ? 'border-[#28a745] bg-[#28a745]/5 shadow-md scale-105'
                                                                : 'border-transparent hover:border-gray-300'
                                                                }`}
                                                        >
                                                            {/* ปก */}
                                                            <div className="relative w-full aspect-[2/3] rounded-md overflow-hidden shadow-sm">
                                                                <img
                                                                    src={book.book_image}
                                                                    alt={book.Edata?.name || "cover"}
                                                                    className="object-cover w-full h-full"
                                                                    loading="lazy"
                                                                />
                                                                {isChecked && (
                                                                    <div className="absolute top-1 right-1 w-5 h-5 rounded-full flex items-center justify-center border text-[11px] font-bold bg-[#28a745] border-[#28a745] text-white scale-110">
                                                                        ✓
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* เล่มที่ */}
                                                            <p className="mt-1 text-xs text-center font-medium text-gray-700 line-clamp-2 leading-tight">
                                                                {book.Edata?.name} เล่ม {book.series_number}
                                                            </p>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Confirm button */}
                    <Form.Item className="text-end">
                        <Button
                            htmlType="submit"
                            className="btn-primary text-white"
                            type="primary"
                        >
                            ยืนยัน
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal open={modalsuccess} footer={null} className={`${theme} success_modal`}>
                <div className="flex flex-col items-center gap-[1em]">
                    <img className="w-[50%]" src="https://eve-image.eveebook.com/image.eveebook/mascot/yeah.png" alt="success" />
                    <div className="text-[24px] font-medium">ได้รับหนังสือเรียบร้อยแล้ว</div>
                    <button onClick={() => {
                        window.location.href = "/library";
                    }} className="btn-primary h-[48px] w-[160px]">ไปที่ชั้นหนังสือ</button>
                </div>
            </Modal>

            <div className={`absolute top-[70px] left-0 sm:left-[5%] md:left-[10%] max-w-[393px] w-full overflow-hidden
                rounded-[8px] text-primary shadow-xl backdrop-blur-md page-surface opacity-95
                transition-[max-height] duration-300 ease-in-out
                ${menu ? 'max-h-[600px]' : 'max-h-0'} `}
            >
                <div className="border-b-[1px] border-[#DEDEDE] flex justify-between items-center py-[10px] px-[30px]">
                    <div className="flex gap-[10px]">
                        <span>โหมดมืด</span>
                        <Switch className="modeselect" value={theme === 'dark_theme'} onChange={() => { theme === 'light_theme' ? setTheme('dark_theme') : setTheme('light_theme') }} />
                    </div>
                </div>
                <div className="border-b-[1px] border-[#DEDEDE]"></div>
                <div>
                    <Link href="/" prefetch={true} onClick={() => setMenu?.(false)} className="flex px-[30px] usermenu justify-between items-center h-[48px]">
                        <span>หน้าแรก</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>
                    <Link href="/search" onClick={() => setMenu?.(false)} className="flex px-[30px] usermenu justify-between items-center h-[48px]">
                        <span>ค้นหาอีบุ๊ค</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>
                    {hasFreeCampaigns && <Link className="flex px-[30px] usermenu justify-between items-center h-[48px]" href="/free-campaign" onClick={() => setMenu?.(false)}>
                        <span>อ่านฟรี</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>}
                    <Link className="flex px-[30px] usermenu justify-between items-center h-[48px]" href="/preorder" onClick={() => setMenu?.(false)}>
                        <span>พรีออเดอร์</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>
                    <Link href="/promotion" onClick={() => setMenu?.(false)} className="flex px-[30px] usermenu justify-between items-center h-[48px]">
                        <span>โปรโมชั่น</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>
                    <Link href="https://www.facebook.com/share/15wWnQqWGN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" onClick={() => setMenu?.(false)} className="flex px-[30px] usermenu justify-between items-center h-[48px]">
                        <span>ข่าวสาร</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </Link>
                    <div onClick={() => setMenu?.(false)} className="flex px-[30px] usermenu justify-between items-center h-[48px] cursor-pointer">
                        <span>ดาวน์โหลดแอปพลิเคชั่น</span>
                        <FontAwesomeIcon className="text-[12px]" icon={faChevronRight} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileHeaderMenu
